// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"30fb8a79","455":"cc985406","977":"c5917d69"}[chunkId] + ".chunk.js";
};